import { render } from "./BeschreibungsFeld.vue?vue&type=template&id=1371ea8d&scoped=true"
import script from "./BeschreibungsFeld.vue?vue&type=script&lang=js"
export * from "./BeschreibungsFeld.vue?vue&type=script&lang=js"

import "./BeschreibungsFeld.vue?vue&type=style&index=0&id=1371ea8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1371ea8d"]])

export default __exports__